import React from 'react';
import { DashboardModal } from 'containers/Dashboard/components/DashboardModal';
import { APIRequest } from 'api-provider';
import { deleteEquiments } from '../../_shared/resources';
import __ from 'utils/i18n';
import { useDispatch } from 'react-redux';
import { logout } from 'containers/Logout/actions';
import jwt_decode from 'jwt-decode';

const isTokenExpired = (token) => {
  try {
    const decoded = jwt_decode(token);
    const expTime = new Date(decoded.exp * 1000);
    const now = new Date();
    const isExpired = decoded.exp * 1000 < Date.now();
    return isExpired;
  } catch (error) {
    return true;
  }
};

export const DeleteModal = ({ id, token, deleteSuccess, showModal, hideModal }) => {
  const dispatch = useDispatch();
  
  if (!id) return null;

  const handleTokenExpiration = () => {
    if (isTokenExpired(token)) {
      dispatch(logout());
      return true;
    }
    return false;
  };

  return (
    <APIRequest
      resource={deleteEquiments(id, token)}
      onSuccess={(response) => {
        deleteSuccess(id);
        hideModal(false);
      }}
      onFailure={(error) => {
        if (error?.response?.status === 401) {
          handleTokenExpiration();
        }
      }}>
      { request => (
        <DashboardModal
          name='deleteProductModal'
          headerText={__('dashboard.sections.standalone.headerText')}
          showModal={showModal}
          hideModal={() => hideModal(false)}
          submitAction={() => request.fetch({ id })}
          submitDisabled={request.isFetching}
          submitColor='danger'
          submitText={__('actions.delete')}
          cancelText={__('actions.cancel')}
        >
          {__('dashboard.sections.standalone.confirmDelete')}
        </DashboardModal>
      )}
    </APIRequest>
  );
};
